import { ORGANIZER_VIEWS } from "@/lib/organizer";

export const OrganizerTabs = ({ view, counts, onChange }) => (
  <div className="-mx-1 overflow-x-auto pb-1" data-testid="organizer-tabs">
    <div className="flex gap-1 min-w-max px-1">
      {ORGANIZER_VIEWS.map((item) => {
        const active = view === item.key;
        return (
          <button key={item.key} type="button" data-testid={`organizer-tab-${item.key}`} onClick={() => onChange(item.key)} title={item.hint} aria-pressed={active}
            className={`inline-flex items-center gap-2 px-3.5 py-2.5 rounded-full text-sm font-semibold whitespace-nowrap border transition-colors ${active ? "bg-teal-700 border-teal-700 text-white" : "bg-white border-slate-200 text-slate-600 hover:border-teal-300 hover:text-teal-800"}`}>
            {item.label}
            <span data-testid={`organizer-count-${item.key}`} className={`px-2 py-0.5 rounded-full text-xs font-bold ${active ? "bg-white/20 text-white" : "bg-slate-100 text-slate-700"}`}>{counts?.[item.key] ?? "–"}</span>
          </button>
        );
      })}
    </div>
  </div>
);
